var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:telegram-fill",
    clipPath: "url(#clip0_4812_5838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9283 4.1163C20.1742 4.01332 20.4434 3.97781 20.7078 4.01345C20.9722 4.04909 21.2221 4.15459 21.4316 4.31896C21.6411 4.48333 21.8025 4.70057 21.899 4.94807C21.9955 5.19556 22.0235 5.46427 21.9802 5.72621L19.7234 19.347C19.5044 20.6609 18.0556 21.4143 16.8446 20.7599C15.8316 20.2124 14.327 19.3688 12.9737 18.4886C12.297 18.048 10.2243 16.6371 10.479 15.6332C10.6979 14.7747 14.1807 11.549 16.1709 9.63116C16.952 8.8777 16.5958 8.44304 15.6734 9.13611C13.3817 10.8569 9.70483 13.4737 8.48884 14.2104C7.41614 14.8599 6.8569 14.9708 6.1882 14.8599C4.96823 14.6579 3.83682 14.345 2.91338 13.9638C1.66554 13.449 1.72624 11.7421 2.91238 11.245L19.9283 4.1163Z",
    fillOpacity: 0.7
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4812_5838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f0cd11c0384a9884c9ae2e296a541a27.svg";
export { ForwardRef as ReactComponent };